// initialize whole foundation
$(document).foundation();

$(function () {
	// initialize nette ajax plugin
	$.nette.init();
	window.NProgress.configure({showSpinner: false});

	// verify javascript while signing in to game (it's used to check coordinates)
	$('input[name=js]', $('#frm-signInForm')).val(1);

	// initialize gps checker
	if (window.brko.gpsReportingUrl) {
		let gpsStarted = false;

		const startGpsOnInteraction = function() {
			if (gpsStarted) return;
			gpsStarted = true;

			window.brko.gpsChecker.start({reportingUrl: window.brko.gpsReportingUrl});

			document.removeEventListener('click', startGpsOnInteraction);
			document.removeEventListener('touchstart', startGpsOnInteraction);
			document.removeEventListener('keydown', startGpsOnInteraction);
		};

		document.addEventListener('click', startGpsOnInteraction);
		document.addEventListener('touchstart', startGpsOnInteraction);
		document.addEventListener('keydown', startGpsOnInteraction);
	}

	// initialize all count downs on page
	window.brko.countdown.init();

	// initialize confirmation dialogs
	window.brko.confirmation.init(Foundation.utils.S('#confirmationDialog'));

	// initialize choosing sites from map
	window.brko.mapWidget({mapContainerId: "chooseMap"});
	// initialize map for verifying location
	window.brko.mapWidget({mapContainerId: "locationMap"});

	// initialize 360 photos
	window.brko.pannellum();

	// initialize image slider (before/after images)
	window.brko.imageSlider();
});
